import { Button } from '@/components/ui/button'

interface ScrollToBottomButtonProps {
  show: boolean
  newMessagesCount: number
  onClick: () => void
}

export function ScrollToBottomButton({ show, newMessagesCount, onClick }: ScrollToBottomButtonProps) {
  if (!show) return null

  return (
    <div className="absolute bottom-6 left-0 right-0 flex justify-center z-20 pointer-events-none">
      <Button
        onClick={onClick}
        size="sm"
        className={`pointer-events-auto rounded-full shadow-lg border-none px-6 py-2.5 font-medium transition-all duration-200 ${
          newMessagesCount > 0
            ? 'bg-gradient-to-r from-emerald-600 to-emerald-500 hover:from-emerald-500 hover:to-emerald-400 shadow-emerald-500/30 text-white'
            : 'bg-slate-100 dark:bg-zinc-700/90 hover:bg-slate-200 dark:hover:bg-zinc-600 backdrop-blur-sm text-slate-700 dark:text-white border border-slate-200 dark:border-transparent'
        }`}
      >
        {newMessagesCount > 0 ? (
          <span className="text-sm">
            {newMessagesCount} nova{newMessagesCount > 1 ? 's' : ''} mensagen{newMessagesCount > 1 ? 's' : 'm'}
          </span>
        ) : (
          <span className="text-sm">Ir para o final</span>
        )}
      </Button>
    </div>
  )
}
